angular.module('unergie.main')
.directive('interventiontimeline', () =>
    ({
        restrict: 'E',
        templateUrl: '/directives/interventiontimeline/interventiontimeline.html',
        scope: {
            date: '=',
            slot: '=',
            available: '=',
        },
        link($scope) {
            $scope.isAvailable = (slot) => ($scope.available != null ? $scope.available.indexOf(slot) : undefined) > -1

            $scope.isSelected = function (slot) {
                let selected = $scope.slot.slot === slot
                if (selected && $scope.date) {
                    selected = moment($scope.slot.date).isSame(moment($scope.date))
                }
                return selected
            }

            $scope.select = function (slot) {
                if ($scope.isAvailable(slot)) {
                    $scope.slot.slot = slot
                }
                if ($scope.date) {
                    return ($scope.slot.date = $scope.date)
                }
            }
        },
    }),
)
